export const nativeCallBackMethod = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForDeviceInfo = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForCamera = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForCamera = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const downloadPDFFromBase64 = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForBase64 = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};
